import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { SensitiveData } from "@/components/sensitive-data";
import { formatCurrency } from "@/lib/utils";
import type { ForecastPerformance } from "../types";

interface ForecastMarginCardProps {
  performance: ForecastPerformance;
}

export function ForecastMarginCard({ performance }: ForecastMarginCardProps) {
  const { summary, rows, marginBadge, forecastMarginGbp, forecastMarginPercent } = performance;

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <CardTitle className="text-sm font-medium">Forecast Margin</CardTitle>
          {summary && (
            <span className={`text-xs px-1.5 py-0.5 rounded-full font-medium ${marginBadge.cls}`}>
              {marginBadge.label}
            </span>
          )}
        </div>
      </CardHeader>
      <CardContent>
        {summary ? (
          <>
            <div className={`text-2xl font-bold ${
              forecastMarginPercent >= 15
                ? 'text-success-600'
                : forecastMarginPercent >= 5
                ? 'text-warning-600'
                : 'text-error-600'
            }`}>
              <SensitiveData>{forecastMarginPercent.toFixed(1)}%</SensitiveData>
            </div>
            <p className="text-xs text-muted-foreground mt-1">Forecast Gross Margin %</p>
            <div className="mt-3 space-y-1.5 text-xs">
              <div className="flex justify-between">
                <span className="text-muted-foreground">Budget GM%</span>
                <span className="font-medium">{rows.budgetMarginPercent.toFixed(1)}%</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Variance</span>
                <span className={`font-medium ${rows.marginVariance >= 0 ? 'text-success-600' : 'text-error-600'}`}>
                  {rows.marginVariance >= 0 ? '+' : ''}{rows.marginVariance.toFixed(1)}pp
                </span>
              </div>
              <div className="border-t pt-1.5 mt-1" />
              <div className="flex justify-between">
                <span className="text-muted-foreground">Forecast GP (£)</span>
                <SensitiveData>
                  <span className={`font-medium ${forecastMarginGbp >= 0 ? 'text-success-600' : 'text-error-600'}`}>
                    {formatCurrency(forecastMarginGbp)}
                  </span>
                </SensitiveData>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="text-2xl font-bold text-muted-foreground">—</div>
            <p className="text-xs text-muted-foreground mt-1">Forecast Gross Margin %</p>
            <p className="mt-3 text-xs text-muted-foreground italic">No forecast data committed yet.</p>
          </>
        )}
      </CardContent>
    </Card>
  );
}
